module.exports = __webpack_public_path__ + "static/media/1080x642-desktop.f7fff39c.jpg";